/**
 * Пункти «Завантажити як GeoJSON» — лише для таблиць, де провізія позначила координати.
 *
 * Позначку (`widgetOptions.regionalGeo`) читаємо з метаданих документа — з того самого місця, що
 * й сервер, який віддає файл. Тож пункт з'являється рівно тоді, коли вивантаження спрацює: на
 * таблиці без координат його немає, на 60/homelessAnimals їх два — «місця відлову» і «місця
 * випуску» (рішення власника Г4). [[vyvantazhennia-geojson]]
 */
import { GristDoc } from "app/client/components/GristDoc";
import { hooks } from "app/client/Hooks";
import { makeT } from "app/client/lib/localization";
import { ColumnRec, ViewSectionRec } from "app/client/models/DocModel";
import { testId } from "app/client/ui2018/cssVars";
import { menuItemLink } from "app/client/ui2018/menus";
import { GeoLayer, geoLayers, layerOfColumn } from "app/common/RegionalGeoJSON";

import { DomElementArg } from "grainjs";

const t = makeT("RegionalGeo");

/** Пари координат таблиці віджета. */
export function sectionGeoLayers(viewSection: ViewSectionRec | null | undefined): GeoLayer[] {
  const table = viewSection?.table.peek();
  if (!table) {
    return [];
  }
  return geoLayers(table.columns.peek().peek().map(col => ({
    colId: col.colId.peek(),
    widgetOptions: col.widgetOptions.peek(),
  })));
}

/** Пара координат, до якої належить колонка, або `null`: для кнопки «Точка на мапі». */
export function columnGeoLayer(column: ColumnRec): GeoLayer | null {
  const layers = geoLayers(column.table.peek().columns.peek().peek().map(col => ({
    colId: col.colId.peek(),
    widgetOptions: col.widgetOptions.peek(),
  })));
  return layerOfColumn(layers, column.colId.peek());
}

/**
 * Пункти меню для віджета: `widget` — меню самого віджета, `export` — «Експорт як…» у верхній
 * панелі. `args` — те, що меню додає до кожного пункту (наприклад, обробник кліку).
 */
export function geoJsonMenuItems(
  gristDoc: GristDoc,
  viewSection: ViewSectionRec | null | undefined,
  place: "widget" | "export",
  ...args: DomElementArg[]
) {
  return sectionGeoLayers(viewSection).map(layer => menuItemLink(
    ...args,
    hooks.maybeModifyLinkAttrs({ href: gristDoc.getGeoJsonLink(layer.key || undefined), target: "_blank", download: "" }),
    place === "widget" ?
      (layer.label ? t("Download as GeoJSON — {{layer}}", { layer: layer.label }) : t("Download as GeoJSON")) :
      (layer.label ? t("GeoJSON — {{layer}} (.geojson)", { layer: layer.label }) : t("GeoJSON (.geojson)")),
    testId(place === "widget" ? "download-section" : "tb-share-option"),
  ));
}
